import React, { useContext } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Box, Button, Stack, Tab, Tabs, Typography } from '@mui/material'
import { UserContext } from '../../../App'
import { canEditLoadLists } from './makeReadyAccess'

const TABS = [
  { key: 'board', label: 'Board', path: '/make-ready-overview' },
  {
    key: 'loadLists',
    label: 'Load Lists',
    path: '/make-ready-load-lists',
    requiresEditor: true,
  },
  { key: 'history', label: 'History', path: '/make-ready-history' },
]

// Shell for the Make Ready module: one page header + Board / Load Lists /
// History tabs. The check page and restock queue stay outside it so they
// keep their own task-focused headers.
const MakeReadyModuleLayout = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { user } = useContext(UserContext)
  const showLoadLists = canEditLoadLists(user)

  const tabs = TABS.filter((tab) => !tab.requiresEditor || showLoadLists)
  const activeTab =
    tabs.find((tab) => pathname.startsWith(tab.path))?.key ?? 'board'

  return (
    <Stack gap={2}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={1}
      >
        <Typography variant="title2">Make Ready</Typography>
        <Button
          variant="outlined"
          size="small"
          onClick={() => navigate('/make-ready-restock-queue')}
        >
          Restock Queue
        </Button>
      </Stack>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={(_e, key) => {
            const target = tabs.find((tab) => tab.key === key)
            if (target) navigate(target.path)
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          {tabs.map((tab) => (
            <Tab key={tab.key} value={tab.key} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      <Outlet />
    </Stack>
  )
}

export default MakeReadyModuleLayout
